export default __webpack_public_path__ + "static/media/science-tech-mobile.f8e8a06a.jpg";